import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-Lancement',
  subtitle: 'Consultez les données de la checklist Go Live et définissez la date de contrôle post-lancement.',
  go_live_checklist: {
    labels: {
      yes: 'Oui',
      no: 'Non',
    },
    title: 'Checklist Go Live',
    form: {
      is_google_business_available: {
        label: 'Google Business disponible',
      },
      is_smart_pricing_configured: {
        label: 'Prix inférieurs à Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Flyer promo envoyé',
      },
      is_menu_fully_configured: {
        label: 'Tous les articles du menu disponibles',
      },
      has_offers_on_competitor_platforms: {
        label:
          'Le restaurant a-t-il des offres actives sur Wolt, Uber, Lieferando (hors offre de livraison gratuite) ?',
      },
      is_instagram_story_shared: {
        label: 'Story Instagram partagée avec le propriétaire',
      },
      is_order_system_connected_to_website: {
        label: 'Site Foodamigos connecté OU bouton de commande en ligne ajouté sur le site du restaurant',
      },
      google_business_connected_by: {
        label: "Comment avons-nous obtenu l'accès au profil Google Business ?",
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
            'Le responsable commercial a invité google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Le responsable commercial a envoyé lui-même la première demande depuis le téléphone du propriétaire',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            "Le responsable onboarding a demandé le profil Google Business (le RC n'a pas invité ni demandé l'accès)",
          null: 'N/A',
        },
      },
    },
    buttons: {
      save: 'Enregistrer',
    },
    toasts: {
      success: 'Enregistré avec succès',
      error: "Échec de l'enregistrement",
    },
  },
  post_launch_screening: {
    title: 'Contrôle post-lancement',
    form: {
      screening_date: {
        label: 'Date de contrôle',
      },
    },
    toasts: {
      success: 'Enregistré avec succès',
      error: "Échec de l'enregistrement",
    },
    buttons: {
      save: 'Enregistrer',
    },
  },
};
